
import { Component } from "vue-property-decorator";
import { QInput } from "quasar";

import {} from "googlemaps";

@Component
export default class AutocompleteInputSearch extends QInput {
  mounted() {
    const inputField: HTMLInputElement = this.$refs.input as HTMLInputElement;
    // eslint-disable-next-line no-undef
    const autocomplete: google.maps.places.SearchBox = new google.maps.places.SearchBox(inputField);

    autocomplete.addListener("places_changed", () => {
      const places = autocomplete.getPlaces();

      if (places.length > 0) {
        const place = places[0];

        if (place.formatted_address) {
          this.$emit("input", place.formatted_address);
        }

        this.$emit("changeplace", place);
      } else {
        this.$emit("changeplace", null);
      }
    });
  }
}
